import { useCallback, useMemo } from "react"
import { ResponsiveItemList } from "./ResponsiveItemList"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

interface CategorySelectorProps {
  categories: string[]
  selectedCategory: string
  onSelectCategory: (category: string) => void
}

export default function CategorySelector({
  categories,
  selectedCategory,
  onSelectCategory,
}: CategorySelectorProps) {
  const renderCategory = useCallback(
    (category: string, isVisible: boolean) => (
      <button
        className={cn(
          "capitalize rounded-system-xl p-system-xs cursor-pointer leading-none whitespace-nowrap",
          selectedCategory === category
            ? "underline underline-offset-[10px]"
            : "",
          !isVisible && "hover:bg-system-blue-700 rounded-system-sm",
        )}
        onClick={() => onSelectCategory(category)}
      >
        {category}
      </button>
    ),
    [onSelectCategory, selectedCategory],
  )

  const alphabeticallySortedCategories = useMemo(
    () => categories.sort((a, b) => a.localeCompare(b)),
    [categories],
  )

  return (
    <ResponsiveItemList
      items={alphabeticallySortedCategories}
      renderItem={renderCategory}
      getKey={category => category}
      containerClassName="h-system-xl"
      dropdownClassName="w-[300px]"
      dropdownItemClassName="bg-system-blue-700"
      moreButtonContent={count => `+${count} more`}
    />
  )
}
